import React from "react";

const truncate = (text, length = 40) => {
  if (!text) return "";
  return text.length > length ? `${text.slice(0, length)}...` : text;
};

const formatDateTime = (d) => {
  if (!d) return "--";
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const AIPitchdeck = ({ activity }) => {
  return (
    <>
      {activity ? (
        <>
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <tr>
                <th className="">User</th>
                <th className="">Topic</th>
                <th className="">Slides</th>
                <th className="">Time</th>
              </tr>
            </thead>
            {activity.length > 0 &&
              activity.map((res, i) => (
                <tr key={i} className="my-2 pt-2">
                  <td className=" my-2 pt-2">
                    {`${res.userId?.name} (${res.userId?.email})`}
                  </td>
                  <td className=" my-2 pt-2" title={res.topic}>
                    {truncate(res.topic)}
                  </td>
                  <td className=" my-2 pt-2">{res.slideCount}</td>
                  <td className="">{formatDateTime(res.updatedAt)}</td>
                </tr>
              ))}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default AIPitchdeck;
